/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for InvoiceOperations controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, InvoiceSummaryResponse, InvoiceSuggestionsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class InvoiceOperationsService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getInvoiceSummaryApiInvoiceSummaryGet(caseId: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<InvoiceSummaryResponse>;
    getInvoiceSummaryApiInvoiceSummaryGet(caseId: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<InvoiceSummaryResponse>>;
    getInvoiceSummaryApiInvoiceSummaryGet(caseId: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<InvoiceSummaryResponse>>;
    /** Get comprehensive invoice validation summary with checks and recommendations */
    getInvoiceSummaryApiInvoiceSummaryGet(caseId: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/invoice_summary`;

        let params = new HttpParams();
        if (caseId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, caseId, 'caseId');
        }

        const requestOptions: any = {
            observe: observe as any,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getSuggestionsApiInvoiceSuggestionsGet(caseId: string, isFreshLoad?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<InvoiceSuggestionsResponse>;
    getSuggestionsApiInvoiceSuggestionsGet(caseId: string, isFreshLoad?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<InvoiceSuggestionsResponse>>;
    getSuggestionsApiInvoiceSuggestionsGet(caseId: string, isFreshLoad?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<InvoiceSuggestionsResponse>>;
    /** Get AI-generated conversation starters for an invoice */
    getSuggestionsApiInvoiceSuggestionsGet(caseId: string, isFreshLoad?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/invoice_suggestions`;

        let params = new HttpParams();
        if (caseId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, caseId, 'caseId');
        }
        if (isFreshLoad != null) {
            params = HttpParamsBuilder.addToHttpParams(params, isFreshLoad, 'isFreshLoad');
        }

        const requestOptions: any = {
            observe: observe as any,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
